module.exports = __webpack_public_path__ + "img/not-seq-2.675bad4d.jpg";